/**
 * Brand Utilities - Minimal JS helper for edge cases
 * Use CSS utilities (brand-utilities.css) for most styling needs
 */

const BrandUtils = {
  /**
   * Get computed brand color from CSS variable
   * @returns {string} hex color or fallback
   */
  getBrandColor() {
    const computed = window.getComputedStyle(document.body);
    const brandColor = computed.getPropertyValue('--brand-color').trim() || '#ffffff';
    return brandColor;
  },

  /**
   * Check if brand color is light or dark
   * @param {string} color - hex color
   * @returns {boolean} true if light, false if dark
   */
  isLightColor(color) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;
    return brightness > 155;
  },

  /**
   * Apply contrast text color based on background
   * @param {HTMLElement} element - element to style
   */
  applyContrastText(element) {
    const brandColor = this.getBrandColor();
    const textColor = this.isLightColor(brandColor) ? 'black' : 'white';
    // element.style.color = textColor;
    element.dataset.brandTextColor = textColor;
  },

  /**
   * Initialize contrast text for all elements with data-brand-contrast
   */
  initContrastText() {
    document.querySelectorAll('[data-brand-contrast]').forEach(el => {
      this.applyContrastText(el);
    });
  }
};

// Auto-initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    BrandUtils.initContrastText();
  });
} else {
  BrandUtils.initContrastText();
}